import { DateInput, DateTimeInput, FormDataConsumer } from 'react-admin';
import { timedInputProps, wholeDayInputProps } from './holidayTemplateForm';

/**
 * Start/End for a holiday template. A whole-day holiday gets plain date pickers; an "Event"
 * (allDay off) keeps hours and minutes. [PROD-28995]
 */
const HolidayTemplateDateInputs = () => (
  <FormDataConsumer>
    {({ formData }) =>
      formData?.allDay ? (
        <>
          <DateInput source="startTime" label="Start Date" isRequired {...wholeDayInputProps} />
          <DateInput source="endTime" label="End Date" isRequired {...wholeDayInputProps} />
        </>
      ) : (
        <>
          <DateTimeInput source="startTime" label="Start Date & Time" isRequired {...timedInputProps} />
          <DateTimeInput source="endTime" label="End Date & Time" isRequired {...timedInputProps} />
        </>
      )
    }
  </FormDataConsumer>
);

export default HolidayTemplateDateInputs;
